import React, { useState } from 'react';
import { map } from 'lodash';
import { Row, Col, Label, ButtonToolbar, Button, Slider, Modal } from 'angieslist-react-components';
import { Track } from 'angieslist-app-platform';
import cookieUtils from 'angieslist-app-platform/lib/common/utils/cookieUtils';
import BusinessHighlightsForm from './BusinessHighlightsForm';
import businessHighlightsImage from '../../../../static/business_highlights.svg';
import './BusinessHighlightsCard.scss';

type Props = {
    hasBusinessHighlights: boolean,
    businessHighlights: Object,
    chunkedHighlights: Array<any>,
    allBusinessHighlights: Array<any>,
    updateBusinessHighlights: Function,
};

export const BusinessHighlightsCard = ({
  hasBusinessHighlights,
  businessHighlights,
  chunkedHighlights,
  allBusinessHighlights,
  updateBusinessHighlights,
}: Props) => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const setUsercookie = () => cookieUtils.setCookie('userClosedHighlightsModal');
  const userClosedHighlightsModal = cookieUtils.getCookie('userClosedHighlightsModal');

  return (
    <div id="Business-Highlights--Container">
      <div id="Business-Highlights--Modal-Container">
        <Modal show={show} onHide={handleClose} onExit={setUsercookie} id="Business-Highlights--Modal">
          <Modal.Header closeButton>
            <Modal.Title />
          </Modal.Header>
          <Modal.Body>
            <BusinessHighlightsForm
              allBusinessHighlights={allBusinessHighlights}
              businessHighlights={businessHighlights}
              isDashboard
              handleClose={handleClose}
              updateBusinessHighlights={updateBusinessHighlights}
            />
          </Modal.Body>
        </Modal>
      </div>
      <Choose>
        <When condition={hasBusinessHighlights && businessHighlights.length < 4}>
          <div className="Business-Highlights--Highlights">
            <Row>
              <Col xs={12}>
                <h4 className="text-center">Your Business Highlights</h4>
              </Col>
            </Row>
            <Row className="highlights-container text-center">
              {
              map(businessHighlights, highlight => (
                <Col xs={12} md={4} key={highlight.name}>
                  <div className="highlight-item text-center">
                    <div className="highlight-image-wrapper">
                      <img alt={highlight.description} src={highlight.iconUrl} className="highlight-image" />
                    </div>
                    <span className="highlight-text">{highlight.description}</span>
                  </div>
                </Col>
              ))
            }
            </Row>
            <ButtonToolbar className="cta-toolbar" style={{ marginTop: 25 }}>
              <Track>
                <Button
                  id="Business-Highlights--Edit-Highlights"
                  bsStyle="link"
                  bsSize="small"
                  className="cta-button text-info"
                  onClick={handleShow}
                  ghost
                >
                Edit Business Highlights
                </Button>
              </Track>
            </ButtonToolbar>
          </div>
        </When>
        <When condition={hasBusinessHighlights && businessHighlights.length > 3}>
          <div className="Business-Highlights--Highlights">
            <Row className="text-center">
              <Col xs={12}>
                <h4 className="text-center">Your Business Highlights</h4>
              </Col>
            </Row>
            <Row className="highlights-container overThreeItems">
              <Col xs={12}>
                <div id="Business-Highlights--Slider-Container" className="hidden-xs">
                  <Slider>
                    {
                    map(chunkedHighlights, (entry, index: any) => (
                      <div className="bh-slide" key={`chunked-slide-parent-${index}`}>
                        {
                          map(entry, entryDetail => (
                            <Col xs={4} sm={4} key={entryDetail.name}>
                              <div className="highlight-item text-center">
                                <div className="highlight-image-wrapper">
                                  <img alt={entryDetail.description} src={entryDetail.iconUrl} className="highlight-image" />
                                </div>
                                <span className="highlight-text">{entryDetail.description}</span>
                              </div>
                            </Col>
                          ))
                        }
                      </div>
                    ))
                  }
                  </Slider>
                </div>
              </Col>
            </Row>
            <Row className="highlights-container text-center visible-xs">
              {
              map(chunkedHighlights[0], highlight => (
                <Col xs={12} md={4} key={`chunked-row-${highlight.name}`}>
                  <div className="highlight-item text-center top-3-mobile-only">
                    <div className="highlight-image-wrapper">
                      <img alt={highlight.description} src={highlight.iconUrl} className="highlight-image" />
                    </div>
                    <span className="highlight-text">{highlight.description}</span>
                  </div>
                </Col>
              ))
            }
            </Row>
            <ButtonToolbar className="cta-toolbar" style={{ marginTop: 25 }}>
              <Track>
                <Button
                  id="Business-Highlights--Edit-Highlights"
                  bsStyle="link"
                  bsSize="small"
                  className="cta-button text-info"
                  onClick={handleShow}
                  ghost
                >
              Edit Business Highlights
                </Button>
              </Track>
            </ButtonToolbar>
          </div>
        </When>
        <When condition={!hasBusinessHighlights && userClosedHighlightsModal}>
          <div className="Business-Highlights--Highlights">
            <Row id="Business-Highlights--No-Highlights">
              <Col xs={12} className="text-center">
                <h4 style={{ marginBottom: 0 }}>Help Your Business Standout</h4>
                <h5>Highlight what makes your business unique.</h5>
              </Col>
            </Row>
            <ButtonToolbar className="cta-toolbar" style={{ marginTop: 25 }}>
              <Track>
                <Button
                  id="Business-Highlights--Edit-Highlights"
                  bsStyle="link"
                  bsSize="small"
                  className="cta-button text-info"
                  onClick={handleShow}
                  ghost
                >
              Add Highlights
                </Button>
              </Track>
            </ButtonToolbar>
          </div>
        </When>
        <Otherwise>
          <Row id="Business-Highlights--Highlights">
            <Col xs={12} id="Business-Highlights--New-Label-Container">
              <Label id="new-label">NEW</Label>
            </Col>
            <Col xs={12} className="text-center">
              <img
                src={businessHighlightsImage}
                id="Business-Highlights--Image"
                title="Business Highlights Phone"
                alt="Business Highlights Phone"
              />
              <h4>Help Your Business Standout</h4>
              <h5>Highlight what makes your business unique.</h5>
              <ButtonToolbar className="cta-toolbar">
                <Track>
                  <Button
                    id="Generic-Card--Business-Highlights"
                    bsStyle="link"
                    bsSize="small"
                    className="cta-button text-info"
                    onClick={handleShow}
                    ghost
                  >
                    Learn More
                  </Button>
                </Track>
              </ButtonToolbar>
            </Col>
          </Row>
        </Otherwise>
      </Choose>
    </div>
  );
};

export default (BusinessHighlightsCard);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/DashboardV2/Card/BusinessHighlightsCard.js